import React, {useState,useRef} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import {getSessionState} from "../../hooks/useSessionState";
import Filtro from "../../shared/componentes/filtro";
import FieldCalendarRange from "../../shared/controls/fieldCalendarRange";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import {Sidebar} from "primereact/sidebar";
import DetalleMovimientos from "./movimientoDetalle";
import useApiMovimientos from "../../api/administracion/useApiMovimientos";
import AgregarDescuento from "./Descuento";
import constantes from "../../catalogos/constantes";
import useSeguridad from "../../Seguridad/useSeguridad";
import alerts from "../../shared/alerts";
import {Dialog} from "primereact/dialog";
import FieldTextArea from "../../shared/controls/fieldTextArea";
import {Button} from "primereact/button";

const Movimientos = ({esSeccionAutorizar, soloLectura, esquemaPagos}) => {

    const filtroKey = 'FiltroMovimientos' + (esSeccionAutorizar ? "PorAutorizar" : "");
    const [datos, setDatos] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [movimientoId, setMovimientoId] = useState(false);
    const api = useApiMovimientos();
    const seguridad = useSeguridad();
    const [nuevoDescuento, setNuevoDescuento] = useState(false);

    const permisoOficina = seguridad.tieneAcceso(constantes.opciones.BusquedaMovsOficina);
    const permisoStaff = seguridad.tieneAcceso(constantes.opciones.BusquedaMovsStaff);
    const permisoOperativos = seguridad.tieneAcceso(constantes.opciones.BusquedaMovsOperativos);

    const [verModal, setVerModal] = useState(false);
    const [comentario, setComentario] = useState("");

    const [, setFiltro] = useState(null);
    const filtroRef = useRef(null);

    async function buscar(filtroBusqueda, paramsApi) {
        setFiltro(filtroBusqueda);
        filtroRef.current = filtroBusqueda;

        agGridHelper.showLoad(gridApi, paramsApi, true);
        setDatos(await api.filtrar(obtenerFiltro(filtroBusqueda)));
        agGridHelper.hideLoad(gridApi, paramsApi, false);
    }

const obtenerFiltro = (filtro) => {
    filtro = filtro ?? getSessionState(filtroKey) ?? {};
    let esquemaDefault = [constantes.esquemaPago.liquidacion];
    let esquema = Array.isArray(filtro.esquemaPagos) && filtro.esquemaPagos.length > 0
        ? filtro.esquemaPagos
        : esquemaDefault;

    return {
        ...filtro,
        porAutorizar: esSeccionAutorizar,
        esquemaPagos: esquema,
        fechas: filtro.fechas ?? null
    };
};


    const onGridReady = async (params) => {
        setGridApi(params.api);
    };

    async function onSave() {
        setSidebarVisible(false);
        setNuevoDescuento(false);
        await buscar();
    }

    const verMovimiento = (id) => {
        setSidebarVisible(true);
        setMovimientoId(id);
    };

    async function autorizar(id, esquemaPago, esRechazar = false) {
        setMovimientoId(id);

        if (esRechazar) {
            setComentario("");
            setVerModal(true);
        } else {
            if (await alerts.preguntarSiNo(`${esRechazar ? "Rechazar movimiento" : "Aprobar movimiento"}, ¿deseas continuar?`)) {
                await api.autorizar(id);
                await buscar();
            }
        }
    }
async function handleClick(esquemaPagoSeleccionado) {
    let filtroActual = getSessionState(filtroKey) || {};
    filtroActual.esquemaPagos = [esquemaPagoSeleccionado];
    sessionStorage.setItem(filtroKey, JSON.stringify(filtroActual));
    await buscar(filtroActual);
}

function exportar() {
    let filtroActual = getSessionState(filtroKey) ?? {};
    let esquemasPermitidos = [];

    if (permisoOperativos)
        esquemasPermitidos.push(constantes.esquemaPago.liquidacion);

    if (permisoStaff)
        esquemasPermitidos.push(constantes.esquemaPago.staff);

    if (permisoOficina)
        esquemasPermitidos.push(constantes.esquemaPago.oficina);
    const filtroFinal = {
        empleados: filtroActual.empleados ?? [],
        tiposMovimiento: filtroActual.tiposMovimiento ?? [],
        conceptosMovs: filtroActual.conceptosMovs ?? [],
        fechas: filtroActual.fechas ?? null,
        estatus: filtroActual.estatus ?? [],
        porAutorizar: filtroActual.porAutorizar ?? esSeccionAutorizar,
        esquemaPagos: esquemasPermitidos
    };

    api.excel(filtroFinal);
}

    const ButtonsHeader = () => {
        return (
            <div className="ag-grid header-icons">
                <ButtonIcon title="Descargar" onClick={exportar} iconName="BiDownload"/>
                {esSeccionAutorizar && !soloLectura &&
                <ButtonIcon
                    title="Agregar descuento"
                    className="grid-action"
                    iconName="MdAddBox"
                    onClick={() => setNuevoDescuento(true)}
                />}
            </div>
        );
    };

    const RowButtons = ({data}) => (
        <div className="ag-grid row-icons">
            <button className="btn btn-link btn-sm" title={'Ver'} onClick={() => verMovimiento(data.id)}>
                Ver
            </button>
        </div>
    );

    const AutorizarCellRenderer = ({data}) => (
        <div className="d-flex align-items-center justify-content-center">
            {!soloLectura &&
            <>
                <button title="Autorizar" type="button" className="button-icon"
                        onClick={() => autorizar(data.id, data.esquemaPagos)}>
                    <i className="pi pi-check-circle text-success"/>
                </button>
            </>}
        </div>
    );

    const RechazarCellRenderer = ({data}) => (
        <div className="d-flex align-items-center justify-content-center">
            {!soloLectura &&
            <>
                <button title="Rechazar" type="button" className="button-icon"
                        onClick={() => autorizar(data.id, data.esquemaPagos, true)}>
                    <i className="pi pi-times-circle text-danger"/>
                </button>
            </>}
        </div>
    );

    const rechazar = async () => {
        await api.rechazar(movimientoId, { comentario: comentario });
        setVerModal(false);
        await buscar();
    };

    const renderFooterModal = () => {
        return (
            <div>
                <Button label="Cerrar" onClick={()=> setVerModal(false)} className="p-button-outlined"/>
                <Button label="Rechazar" onClick={rechazar} autoFocus/>
            </div>
        );
    };

    return (
        <>
            <Filtro filtroKey={filtroKey} handleSubmit={buscar} fechasDiasInicio={1} fechasRangoDias={1}>
                <>
                    {permisoStaff &&
                    <button type="button" onClick={() => handleClick(constantes.esquemaPago.staff)}
                            className="btn btn-sm btn-primary">
                        Movimientos Administrativos
                    </button>}

                    {permisoOperativos &&
                    <button type="button" onClick={() => handleClick(constantes.esquemaPago.liquidacion)}
                            className="btn btn-sm btn-primary">
                        Movimientos Operativos
                    </button>}

                    {permisoOficina &&
                    <button type="button" onClick={() => handleClick(constantes.esquemaPago.oficina)}
                            className="btn btn-sm btn-primary">
                        Movimientos Oficina
                    </button>}
                </>

                <Filtros/>
            </Filtro>

            <Sidebar visible={sidebarVisible} position="right" dismissable={false} className="p-sidebar-md"
                     onHide={() => setSidebarVisible(false)}>
                <DetalleMovimientos movimientoId={movimientoId} onSaved={onSave}
                                    actualizarViajes={buscar} close={() => setSidebarVisible(false)}
                                    editable={!esSeccionAutorizar} soloLectura={soloLectura}/>
            </Sidebar>

            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    frameworkComponents={{
                        buttonsHeader: ButtonsHeader,
                        rowButtons: RowButtons,
                        autorizarCellRenderer: AutorizarCellRenderer,
                        rechazarCellRenderer: RechazarCellRenderer,
                        goToDetail: agGridHelper.GoToDetailFormatter,
                        dateFormatter: agGridHelper.DateTimeFormatter,
                    }}
                    onGridReady={onGridReady}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    rowHeight={35}
                >

                    <AgGridColumn flex={3} minWidth={180} field="fechaSolicitud" headerName="FECHA SOLICITUD"
                                  cellRenderer="dateFormatter"/>

                    <AgGridColumn flex={3} minWidth={180} field="fechaAutorizacion" headerName="FECHA AUTORIZACION"
                                  cellRenderer="dateFormatter"/>

                    <AgGridColumn field="usuarioAutorizo" headerName="EMPLEADO AUTORIZACION" flex={5}
                                  minWidth={260} cellClass={'left'} headerClass={'left'}/>

                    <AgGridColumn field="empleado" headerName="EMPLEADO" flex={5} minWidth={280}
                                  cellClass={'left'} headerClass={'left'}/>

                    <AgGridColumn minWidth={230} field="tipo" headerName="TIPO MOVIMIENTO" flex={5}
                                  cellClass={'left'} headerClass={'left'}/>

                    <AgGridColumn maxWidth={150} field="monto" headerName="MONTO"
                                  cellStyle={{textAlign: "right"}}
                                  valueFormatter={agGridHelper.currencyFormatter}/>

                    <AgGridColumn maxWidth={150} field="tiempoExtra" headerName="TIEMPO EXTRA"
                                  cellStyle={{textAlign: "right"}}
                                  valueFormatter={agGridHelper.decimalFormatter}/>

                    <AgGridColumn minWidth={230} field="concepto" headerName="CONCEPTO"
                                  cellStyle={{textAlign: "center"}}/>

                    <AgGridColumn field="saldoActual" headerName="BALANCE"
                                  cellStyle={{textAlign: "right"}}
                                  maxWidth={150}
                                  valueFormatter={agGridHelper.currencyFormatter}/>

                    <AgGridColumn field="solicitadoPor" headerName="SOLICITADO POR"
                                  cellStyle={{textAlign: "left"}}/>

                    <AgGridColumn maxWidth={100} field="estatus" headerName="ESTATUS"/>
                               
                    <AgGridColumn field="estatusPorComprobar" headerName="ESTATUS COMPROBACIÓN" flex={3}
                                  minWidth={180} cellClass={'left'} headerClass={'left'}/>

                    <AgGridColumn maxWidth={100} hide={!esSeccionAutorizar}
                                  headerName="AUTORIZAR"
                                  cellRenderer="autorizarCellRenderer"/>

                    <AgGridColumn maxWidth={100} hide={!esSeccionAutorizar}
                                  headerName="RECHAZAR"
                                  cellRenderer="rechazarCellRenderer"/>

                    <AgGridColumn maxWidth={80} headerName="VER"
                                  cellRenderer="rowButtons"
                                  pinned={'right'}
                                  cellClass={'left'}
                                  headerComponent="buttonsHeader"/>

                </AgGridReact>
            </div>

            <AgregarDescuento onSave={onSave}
                              visible={nuevoDescuento}
                              hide={() => setNuevoDescuento(false)}/>

            <Dialog header={"Rechazar Movimiento"} visible={verModal}
                    footer={renderFooterModal}
                    style={{width: '60vw'}}
                    onHide={() => setVerModal(false)}>
                <FieldTextArea name="comentarios" label="Comentarios"
                               colMd={12} rows={3}
                               value={comentario}
                               onChange={(value)=>setComentario(value)}/>
            </Dialog>
        </>
    );
};

const Filtros = ({filtro, onChange}) => {
    return (
        <>
            <FieldMultiSelect name="empleados" source="empleados" label="Empleado"
                              colLg={2} colMd={2}
                              value={filtro.empleados}
                              onChange={onChange} showFilter valueAsId={true}/>

            <FieldMultiSelect name="tiposMovimiento" showFilter source="tipoGasto"
                              label="Tipo Movimiento" colMd={2}
                              value={filtro.tiposMovimiento}
                              onChange={onChange} valueAsId={true}/>
          
            <FieldMultiSelect name="coordinadorId" showFilter  label="Coordinador" colMd={2}
                            source="empleados" 
                                        params={{
                                            puestoIds: [constantes.puestos.coordinadorTrafico, constantes.puestos.auxiliarTrafico],
                                            todasLasEmpresas: true
                                        }}                              
                              value={filtro.coordinadorId}
                              onChange={onChange} valueAsId={true}/>
            <FieldMultiSelect name="unidadDeNegocioId" showFilter  label="Unidad Negocio" colMd={2}
                              source="unidadesNegocio"
                              value={filtro.unidadDeNegocioId}
                              onChange={onChange} valueAsId={true}/>
            <FieldMultiSelect name="conceptos" showFilter source="conceptosMovs"
                              label="Conceptos" colMd={2}
                              value={filtro.conceptosMovs}
                              onChange={onChange} valueAsId={true}/>

            <FieldCalendarRange name="fechas" label="Fechas"
                                colLg={2} colMd={3}
                                value={filtro.fechas}
                                onChange={onChange}/>

            <FieldMultiSelect name="estatus" source="estatusMovimiento"
                              label="Estatus"
                              colLg={2} colMd={2}
                              value={filtro.estatus}
                              onChange={onChange}
                              valueAsId={true}/>
        </>
    );
};

export default Movimientos;
